// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2Jres","label":"Radio_label__3Ahtm","checkMark":"Radio_checkMark__5dN7l","disabled":"Radio_disabled__rR2tc"};